import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { BookingsListResponse } from "@/api/types";

type MyBookingsQueryKey = ["bookings"];

type MyBookingsOptions<TData = BookingsListResponse> = Omit<
  UseQueryOptions<BookingsListResponse, Error, TData, MyBookingsQueryKey>,
  "queryKey" | "queryFn"
>;

export function useMyBookings<TData = BookingsListResponse>(options?: MyBookingsOptions<TData>) {
  return useQuery({
    queryKey: ["bookings"],
    queryFn: () => api.get("bookings").json<BookingsListResponse>(),
    staleTime: 30_000,
    ...options,
  });
}
